<template>
  <RsModal
    :value="modelValue"
    :title="$ts('tipTap.editContent')"
    button-text="Ok"
    size="xl"
    is-centered
    no-close-on-backdrop
    dialog-class="rs-modal-tiptap-full-screen"
    @input="$emit('update:modelValue', $event)"
    @submit="handleSubmit"
  >
    <RsFormTipTap
      id="tiptap_full_screen"
      ref="editor"
      :value="content"
      :format="format"
      is-full-screen
      height="65vh"
    />
  </RsModal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { assertRef } from '@/shared/helpers/assert-ref';
import RsFormTipTap from './_global/RsFormTipTap.vue';
import { TTipTapFormat } from '@/shared/tiptap/types';

/**
 * Mostly for use with quill editor, but this modal is just for editing HTML content passed via `html` prop.
 * @emits submit with the updated HTML content.
 */
export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },

    content: {
      type: String,
      default: '',
    },

    format: {
      type: String as PropType<TTipTapFormat>,
      required: true,
    },
  },

  /**
   * Declaring these is load-bearing, not cosmetic. This component's root node is <RsModal>, which
   * emits `submit` (payload-less) and `update:modelValue` itself. Undeclared v-on handlers stay in
   * `$attrs` and fall through onto the root, so a parent's `@submit` would be bound to RsModal
   * *directly* as well as to this component -- RsModal's payload-less `submit` would then call the
   * parent handler with `undefined`, wiping the content that `handleSubmit` had just handed over.
   * Declaring them here removes them from `$attrs` and stops the fallthrough.
   */
  emits: ['submit', 'update:modelValue'],

  methods: {
    handleSubmit() {
      const newContent = assertRef(this.$refs.editor, RsFormTipTap).getHTML(false);
      this.$emit('submit', newContent);
    },
  },
});

</script>

<style lang="scss">
.rs-modal-tiptap-full-screen {
  width: 90% !important;
  max-width: 90% !important;
}
</style>
